function LinkIcon() {
  return (
    <svg width={18} height={18} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.118 3.06a3.25 3.25 0 0 0-4.596 0L9.216 4.364l-.068.077a.75.75 0 0 0 1.128.984l1.306-1.306.106-.098a1.75 1.75 0 0 1 2.37 2.573l-3.536 3.535-.106.097a1.75 1.75 0 0 1-2.736-.633l-.047-.091a.75.75 0 0 0-1.328.69 3.25 3.25 0 0 0 5.277.997l3.536-3.535.127-.134a3.25 3.25 0 0 0-.127-4.462Z'
        fill='white'
      />
      <path
        d='M11.191 6.986a3.25 3.25 0 0 0-4.596 0L3.059 10.52l-.126.134a3.25 3.25 0 0 0 4.723 4.463l1.306-1.306.067-.077A.75.75 0 0 0 7.9 12.75l-1.306 1.306-.106.097a1.75 1.75 0 0 1-2.369-2.572l3.536-3.535.105-.098a1.75 1.75 0 0 1 2.747.658l.045.092a.75.75 0 0 0 1.338-.67 3.244 3.244 0 0 0-.7-1.043Z'
        fill='white'
      />
    </svg>
  );
}

export default LinkIcon;
